import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class TransferredVehicleServiceService {
  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient, 
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
   * Get transferred vehicle record
   * @param transfer_log_id 
   */
  getTransferredVehicleDetails(transfer_log_id: string)
  {

    let apiURL:string=`${this.baseURL}/v1/get-transferred-vehicle-details/${transfer_log_id}`;

    return this.http.get(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));

  }

/**
 * Get vehicle photos
 * @param transfer_log_id 
 * @returns Observable<ApiResponse>
 */
  fetchVehiclePhotos(transfer_log_id: string|null): Observable<ApiResponse>
  {
    let apiURL:string=`${this.baseURL}/v1/get-transferred-vehicle-photos/${transfer_log_id}`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get spare parts vehicle was transferred with
   * @param transfer_log_id 
   * @returns Observable<ApiResponse>
   */
   fetchVehicleSpareParts(transfer_log_id: string|null): Observable<ApiResponse>
   {
     let apiURL:string=`${this.baseURL}/v1/get-transferred-vehicle-spare-parts/${transfer_log_id}`;
 
     return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
   }

  /**
   * Get vehicle activity logs
   * @param transfer_log_id 
   * @returns Observable<ApiResponse>
   */
  fetchVehicleActivityLogs(transfer_log_id: string|null): Observable<ApiResponse>
  {
    let apiURL:string=`${this.baseURL}/v1/get-transferred-vehicle-activity-log/${transfer_log_id}`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Delete vehicle transfer photos 
   * @param vehicleId
   * @param selectedPhotos 
   * @returns 
   */
    deleteVehicleTransferPhotos(vehicleId:string|null,selectedPhotos: any[]): Observable<any> {

      let apiURL:string=`${this.baseURL}/v1/delete-vehicle-transfer-photos`;
  
      const data = {
        vehicle_id:vehicleId,
        selected_photos: selectedPhotos
      };
  
      return this.http.post<any>(apiURL, data);
    }

  /**
   * Get additional spare parts
   * @param transfer_log_id 
   * @returns Observable<ApiResponse>
   */
   fetchAdditionalSpareParts(transfer_log_id: string|null): Observable<ApiResponse>
   {
     let apiURL:string=`${this.baseURL}/v1/vehicle-transfer/releasing/additional-spare-parts/${transfer_log_id}`;
 
     return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
   }

  /**
   * Add more spare parts
   * @param transfer_log_id
   * @param sparePartsToAdd 
   * @returns 
   */
   addSpareParts(vehicle_id:string|null,chassis_no:string|null,transfer_log_id:string|null,sparePartsToAdd: any[]): Observable<any> {

      let apiURL:string=`${this.baseURL}/v1/vehicle-transfer/releasing/add-spare-parts`;
  
      const data = {
        vehicle_id:vehicle_id,
        chassis_no:chassis_no,
        transfer_log_id:transfer_log_id,
        spare_parts: sparePartsToAdd
      };
  
      return this.http.post<any>(apiURL, data);
    }

  /**
   * Remove spare parts
   * @param transfer_log_id
   * @param sparePartsToRemove 
   * @returns 
   */
   removeSpareParts(vehicle_id:string|null,chassis_no:string|null,transfer_log_id:string|null,sparePartsToRemove: any[]): Observable<any> {

    let apiURL:string=`${this.baseURL}/v1/vehicle-transfer/releasing/remove-spare-parts`;

    const data = {
      vehicle_id:vehicle_id,
      chassis_no:chassis_no,
      transfer_log_id:transfer_log_id,
      spare_parts: sparePartsToRemove
    };

    return this.http.post<any>(apiURL, data);
  }
}
